import type { FunctionalErrorItemRendering } from '@functional-errors/models';
import type { CollectionState } from '@innogy/utils-state';
import type { Action, ActionReducerMap } from '@ngrx/store';
import { createFeatureSelector } from '@ngrx/store';

import { functionalErrorReducer } from './functional-errors.reducers';

export interface FunctionalErrorState {
  functionalErrors: CollectionState<FunctionalErrorItemRendering>;
}

export const functionalErrorReducers: ActionReducerMap<
  FunctionalErrorState,
  Action
> = {
  functionalErrors: functionalErrorReducer,
};

export const functionalErrorFeatureKey = 'functionalErrorsFeature';
export const selectFunctionalErrorFeature =
  createFeatureSelector<FunctionalErrorState>(functionalErrorFeatureKey);
